// 개발요청 — 회차별 요청 목록(회차·부서·진행 여부·상태·내 부서만·검색) + 오른쪽 상세(?id= · D4a)
//   + 새 요청 / 고치기 창 · 부서 순위 정렬 창(D4b) + AX 검토 칸·여러 건 일괄 상태(D5a).
// 메뉴 노출·URL 가드는 utils/menuAccess(명시 허용만) · 실제 차단과 비공개 가림은 서버(require_menu("devreq") · serialize_for).
// 🔴 요청 한 건의 단추를 보일지는 서버가 준 item.can.* 으로만 정한다 — 이 화면은 me.is_ax·부서로 권한을 다시 계산하지 않는다.
//    목록 위 «+ 새 요청»·«부서 순위 정렬» 만 /me(open_round · departments)로 정한다(요청 한 건의 권한이 아니다).
//    (me.departments 는 그 밖에 «내 부서 행» 옅은 배경 표시에만 쓴다.)
//    표의 체크 칸·«상태 일괄 변경» 은 /me 의 is_ax 일 때만(서버 bulk-status 가 require_ax) — 한 건이라도 규칙에 걸리면
//    서버가 409 로 아무것도 바꾸지 않고 걸린 요청번호를 준다(그 목록을 보인다).
// 추가 요청 배지(2판 V3) — 제목 옆 «답 필요»(행의 can.answer_ask) · AX 에게는 열린 추가 요청(open_ask)이 있으면 «답 대기».
//    상세는 목록 | 상세 2열(AX 검토 칸은 상세의 ②③ 카드 안 — 오른쪽 칸 없음).
// 위의 탭(D5b) — 요청 목록 · 현황판 · 회차 관리(/me 의 is_ax 일 때만 · 쓰기는 서버가 require_ax). 탭은 주소 ?tab= 로 남는다
//    (목록은 ?tab= 없음 · 알림 링크의 ?id= 와 같이 쓸 수 있다). 회차 관리에서 쓰기가 성공하면 me·rounds·departments 를 다시 읽는다.
// 화면 다듬기(2판 V4) — 상세를 연 동안 표는 간단 열(요청번호·제목·상태 · AX 체크 칸) · 빈 목록 안내(필터 걸림 → 접수 중 회차의 첫 요청
//    → 그 밖) · AX 에게는 «부서가 연결되지 않아…» 안내를 숨긴다 · 회차 고르기는 넓은 화면에서 280~420px 말줄임 + title.
// 목록 | 상세 경계 끌기(넓은 화면) — 상세 폭 [360, min(1200, main−420)] · 놓을 때 저장 · 더블클릭 = 460.
//    표 머리 정렬 — 누를 때마다 오름 → 내림 → 해제(서버 순서) · 빈 값은 늘 맨 뒤 · 화면에서만(서버는 페이지 없이 전부 준다).
//    정렬할 수 있다는 표시 — 모든 머리에 늘 연한 ↕(정렬한 머리만 같은 자리에 진한 ▲/▼).
// 개발 시작일(dev_started_on · 서버 자동 기록 · 손 수정 없음)·실제 완료일 열 — 실제 완료일은 상태가 «완료»일 때만 done_on
//    (완료에서 테스트로 되돌아간 건에 옛 완료일이 보이지 않게 · 서버 값은 그대로).
// 상세 «크게 보기»(넓은 화면만) — 목록 상자·폭 손잡이를 빼고 상세가 main 을 다 쓴다(읽기 폭 960 · 켬/끔은 localStorage 에 기억).
//    «이전 / 다음»(J/K) — 화면에 그린 목록 순서(sortedItems)의 옆 요청 · 끝에서 멈춘다 · 상세에서 저장하면 저장 직전 이웃을 고정한다.
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { IconClipboardList, IconSearch } from '@tabler/icons-react';
import AppShell from '../components/AppShell';
import { Page, PageHeader, PillTabs } from '../components/ui';
import useIsMobile from '../hooks/useIsMobile';
import { scaleOf } from '../lib/floatingBounds';
import { devreqAPI } from '../api/client';
import { COLORS, ICON_STROKE, TONES, btn, card, input } from '../utils/uiStyles';
import DevRequestAdmin from './devreq/DevRequestAdmin';
import DevRequestDashboard from './devreq/DevRequestDashboard';
import DevRequestDetail from './devreq/DevRequestDetail';
import DevRequestForm from './devreq/DevRequestForm';
import DevRequestRankPanel from './devreq/DevRequestRankPanel';
import {
  DECISIONS, MASKED_TITLE, STATUSES, aiScreenView, decisionBadge, fmtDay, roundName, roundStatusBadge, roundStatusLabel, statusBadge, text,
} from './devreq/devreqLabels';

const HEADERS = [
  '요청번호', '부서', '순위', '제목', '요청자', 'AX 담당자', '진행 여부', '우선순위', '예정 완료', '개발 시작일', '실제 완료일', '상태', '확인',
];
// 13열 표의 최소 폭(넓은 화면 · 상세를 닫았을 때) — 11열 960px 에 날짜 두 칸(머리 «개발 시작일 ↕»·값 «2026-10-24» 기준 약 95px)을 더했다.
const TABLE_MIN_W = '1150px';
// 정렬 표시 — 정렬 안 된 머리는 연한 ↕ · 정렬한 머리는 진한 ▲/▼(같은 자리 · 폭은 CSS 로 고정 · 글자는 «공백 + 기호»).
const SORT_HINT = ' ↕';
const sortHintStyle = (on) => ({
  display: 'inline-block', width: '1em', textAlign: 'center', color: on ? COLORS.text : COLORS.textMuted, fontWeight: on ? 700 : 400,
});
// 상세를 연 동안의 간단 열 — 배지(이월·답 필요/답 대기·철회)는 이 세 칸에 그대로 남는다.
const COMPACT_HEADERS = ['요청번호', '제목', '상태'];
const EMPTY_DEFAULT = '요청이 없습니다';
const EMPTY_FILTERED = '조건에 맞는 요청이 없어요';
const EMPTY_FIRST = '아직 요청이 없어요. 위의 «+ 새 요청»으로 첫 요청을 올려 보세요.';
const SEARCH_DELAY_MS = 300;
// 휴대폰 폭 — 표 대신 카드로 그린다(가로 스크롤 없음). 768 = 앱 모바일 경계(≤768 은 모바일 확대 1.5배 · 확대 뒤 배치 폭 512 이하라 1150 표가 안 들어간다).
const MOBILE_QUERY = '(max-width: 768px)';
const th = { height: '33px', padding: '5px 9px', textAlign: 'left', fontSize: '12px', fontWeight: 400, color: COLORS.textMuted, whiteSpace: 'nowrap', borderBottom: `1px solid ${COLORS.borderSoft}` };
const td = { height: '41px', padding: '7px 9px', fontSize: '13px', color: COLORS.textSub, borderBottom: `1px solid ${COLORS.borderSoft}`, whiteSpace: 'nowrap' };
const smallBadge = (background, color) => ({
  display: 'inline-block', padding: '1px 6px', borderRadius: '20px', fontSize: '11px', fontWeight: 500, background, color, whiteSpace: 'nowrap',
});
const CARRIED_BADGE = smallBadge(COLORS.warnSoft, COLORS.warn);
const WITHDRAWN_BADGE = smallBadge(TONES.gray.soft, TONES.gray.ink);
const ANSWER_NEEDED_BADGE = smallBadge(TONES.red.soft, TONES.red.ink);   // 빨강 — 내가 답할 추가 요청(주황 TONES 는 대비 2.36)
const ANSWER_WAITING_BADGE = smallBadge(TONES.gray.soft, TONES.gray.ink);
const MINE_BG = COLORS.primarySoft;
const TAB_LIST = { key: 'list', label: '요청 목록' };
const TAB_DASHBOARD = { key: 'dashboard', label: '현황판' };
const TAB_ADMIN = { key: 'admin', label: '회차 관리' };
// 회차 고르기(넓은 화면) — 이름 길이만큼(280~420px) · 넘치면 말줄임(전체 글자는 title). input 의 width 100% 는 auto 로 푼다.
// 높이 30 에 input 의 위아래 여백 7 이 남으면 글자 칸이 14px 라 아래가 잘린다 → 위아래 여백 0(가로 10 은 그대로).
const ROUND_SELECT_WIDE = {
  ...input, padding: '0 10px', width: 'auto', minWidth: '280px', maxWidth: '420px', height: '30px', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap',
};
const roundOptionText = (r) => `${roundName(r)} (${roundStatusLabel(r.status)})`;

// 상세 패널 폭(넓은 화면 · 목록 | 상세 경계 끌기 · 더블클릭 = 기본 폭). 저장값 = 사용자 선호이고, 화면에는 main 폭에 맞게
// 줄여서만 그린다(AI노트 폴더 패널 MeetingsPage FOLDER_PANEL_* 와 같은 방식 — 창을 좁혔다 넓히면 정한 폭이 돌아온다).
const DETAIL_W_KEY = 'gwDevreqDetailW';
const DETAIL_W_DEFAULT = 460;   // 지금 너비 = 더블클릭 복귀값
const DETAIL_W_MIN = 360;
const DETAIL_W_MAX = 1200;
const LIST_AREA_MIN = 420;      // 목록 최소 폭
const DETAIL_W_STEP = 16;       // 키보드 ←/→ 한 번
// 🔴 최소값이 최대값보다 우선한다 — main 이 780 미만이면 상한이 360 으로 고정되고 목록이 420 아래로 내려가는 것을 허용한다.
//    main 폭 0(모름 · ResizeObserver 없음 · jsdom)이면 1200 상한만 건다.
const detailWMaxFor = (mainW) => (mainW > 0 ? Math.max(DETAIL_W_MIN, Math.min(DETAIL_W_MAX, mainW - LIST_AREA_MIN)) : DETAIL_W_MAX);
const clampDetailW = (px, mainW) => Math.round(Math.min(Math.max(px, DETAIL_W_MIN), detailWMaxFor(mainW)));
const readDetailW = () => {
  try {
    const raw = window.localStorage.getItem(DETAIL_W_KEY);
    // 🔴 null·빈값을 먼저 거른다 — Number(null) === 0 이라 그대로 두면 기본값 대신 360 으로 잘린다.
    if (raw == null || String(raw).trim() === '') return DETAIL_W_DEFAULT;
    const n = Number(raw);
    if (!Number.isFinite(n) || n <= 0) return DETAIL_W_DEFAULT;
    return clampDetailW(n, 0);
  } catch (e) {
    return DETAIL_W_DEFAULT;   // 저장소 접근 불가
  }
};
// 상세 «크게 보기» — 저장값 '1' = 켬(끄면 키를 지운다). 상세를 닫아도 그대로 두어 다음에 열 때도 크게 보기다.
const DETAIL_EXPANDED_KEY = 'gwDevreqDetailExpanded';
const readExpanded = () => {
  try {
    return window.localStorage.getItem(DETAIL_EXPANDED_KEY) === '1';
  } catch (e) {
    return false;   // 저장소 접근 불가
  }
};

// 실제 완료일 — 상태가 «완료»일 때만 완료일(그 밖은 빈 값 · 칸 표시와 정렬이 같은 값을 쓴다).
const actualDoneOn = (it) => (it.status === '완료' ? it.done_on : null);

// 표 머리 정렬 — 머리 글자 → 행의 비교 값. 화면에 보이는 값만 쓴다(가린 행은 서버가 값을 null 로 · 제목은 «비공개 요청»으로 준다).
const SORT_KEYS = {
  요청번호: (it) => it.req_no,
  부서: (it) => it.dept_name,
  순위: (it) => it.dept_rank,
  제목: (it) => (it.masked ? MASKED_TITLE : it.title),
  요청자: (it) => it.requester_name,
  'AX 담당자': (it) => it.assignee_name,   // 미지정·가린 행은 null → 빈 값 규칙(맨 뒤)
  '진행 여부': (it) => it.decision,
  우선순위: (it) => it.priority,
  '예정 완료': (it) => it.plan_end,
  '개발 시작일': (it) => it.dev_started_on,
  '실제 완료일': actualDoneOn,
  상태: (it) => it.status,
  확인: (it) => it.confirm_state,
};
// 순번형 — 글자 순이 아니라 이 목록 순서(진행·보류·반려·통합 · 접수 → 완료).
const SORT_ORDERS = { '진행 여부': DECISIONS, 상태: STATUSES };
const isBlankValue = (v) => v === null || v === undefined || v === '';
// 빈 값(null·'')은 방향과 무관하게 맨 뒤 · 순번형의 목록 밖 값도 빈 값처럼 맨 뒤 · 같으면 0(안정 정렬이라 서버 순서 유지).
function compareBy(header, dir) {
  const get = SORT_KEYS[header];
  const order = SORT_ORDERS[header];
  const sign = dir === 'desc' ? -1 : 1;
  const keyOf = (it) => {
    const v = get ? get(it) : null;
    if (isBlankValue(v)) return null;
    if (order) {
      const i = order.indexOf(v);
      return i < 0 ? null : i;
    }
    return v;
  };
  return (a, b) => {
    const x = keyOf(a);
    const y = keyOf(b);
    if (x === null || y === null) {
      if (x === y) return 0;
      return x === null ? 1 : -1;
    }
    const c = typeof x === 'number' && typeof y === 'number'
      ? x - y
      : String(x).localeCompare(String(y), 'ko', { numeric: true });
    return c * sign;
  };
}

const errorText = (err, fallback) => {
  const detail = err?.response?.data?.detail;
  return typeof detail === 'string' && detail ? detail : fallback;
};

const BULK_FAILED = '상태를 바꾸지 못했습니다.';
const BULK_BLOCKED = '규칙에 걸린 요청이 있어 아무것도 바꾸지 않았습니다.';
// 일괄 상태 실패 → { message, blocked: [{ reqNo, reason }] }. 409 의 detail 은 객체다
//   (routers/devreq.py bulk_status: { code, message, req_nos, blocked: [{ id, req_no, detail }] }).
function bulkErrorOf(err) {
  const detail = err?.response?.data?.detail;
  if (detail && typeof detail === 'object' && !Array.isArray(detail)) {
    let blocked = [];
    if (Array.isArray(detail.blocked) && detail.blocked.length > 0) {
      blocked = detail.blocked.map((b) => ({ reqNo: text(b?.req_no), reason: typeof b?.detail === 'string' ? b.detail : '' }));
    } else if (Array.isArray(detail.req_nos)) {
      blocked = detail.req_nos.map((reqNo) => ({ reqNo: text(reqNo), reason: '' }));
    }
    const message = typeof detail.message === 'string' && detail.message ? detail.message : BULK_BLOCKED;
    return { message, blocked };
  }
  return { message: errorText(err, BULK_FAILED), blocked: [] };
}

// 이월 배지 — 요청번호는 옛 회차 번호 그대로이고 배지가 어디서 왔는지 알려 준다(예: «이월(1회차)»).
const carriedLabel = (item) => `이월(${text(item.carried_from_round_no)}회차)`;
// 가린 행의 제목은 서버 글자와 무관하게 «🔒 비공개 요청».
const titleOf = (item) => (item.masked ? `🔒 ${MASKED_TITLE}` : text(item.title));

export default function DevRequestsPage() {
  const isMobile = useIsMobile(MOBILE_QUERY);
  const [searchParams, setSearchParams] = useSearchParams();
  const rawId = searchParams.get('id') || '';
  const selectedId = /^\d+$/.test(rawId) ? Number(rawId) : null;

  const [me, setMe] = useState(null);
  const [rounds, setRounds] = useState([]);
  const [roundsState, setRoundsState] = useState('loading');   // 'loading' | 'ready' | 'failed'
  const [departments, setDepartments] = useState([]);
  const [roundId, setRoundId] = useState('');
  const [deptId, setDeptId] = useState('');
  const [decision, setDecision] = useState('');
  const [status, setStatus] = useState('');
  const [mine, setMine] = useState(false);
  const [qInput, setQInput] = useState('');
  const [q, setQ] = useState('');
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [detail, setDetail] = useState({ item: null, loading: false, error: '' });
  const [listVersion, setListVersion] = useState(0);   // 쓰기 뒤 목록을 다시 부른다
  // null | { mode: 'create' } | { mode: 'edit', item, thumbs } — thumbs = 상세가 이미 받은 썸네일(id → blob 주소 · 창이 다시 받지 않는다).
  const [form, setForm] = useState(null);
  const [rankOpen, setRankOpen] = useState(false);
  const [selected, setSelected] = useState(() => new Set());   // 일괄 상태로 고른 요청 id(AX)
  const [bulkStatus, setBulkStatus] = useState('');
  const [bulkBusy, setBulkBusy] = useState(false);
  const [bulkError, setBulkError] = useState(null);             // null | { message, blocked }
  const [sort, setSort] = useState({ key: null, dir: null });   // 표 머리 정렬 — key = 머리 글자 · dir = 'asc' | 'desc'
  // 상세 패널 폭 — detailW = 사용자 선호(저장값) · mainW = [목록 | 상세] main 의 실제 폭
  const [detailW, setDetailW] = useState(readDetailW);
  const [mainW, setMainW] = useState(0);
  const [expanded, setExpanded] = useState(readExpanded);   // 상세 «크게 보기»(사용자 선호 · 넓은 화면에서 상세를 열었을 때만 효과)
  const mainRef = useRef(null);
  // «이전 / 다음» — lastPosRef = 현재 요청이 목록에 마지막으로 있던 자리 { id, pos, key } · pinnedNavRef = 상세에서 저장한 요청의
  //   저장 직전 이웃 { id, prevId, nextId, key } · navRef = 지금 화면에 보이는 이웃(고정할 때 읽는다). key = 목록 params + 정렬.
  const lastPosRef = useRef(null);
  const pinnedNavRef = useRef(null);
  const navRef = useRef(null);
  const lastOpenedIdRef = useRef(null);   // 크게 보기에서 돌아올 때 화면 안으로 스크롤할 행
  const wasExpandedRef = useRef(false);
  const mainRoRef = useRef(null);
  const detailDragCleanupRef = useRef(null);   // 끄는 도중 언마운트·상세 닫힘·휴대폰 전환이면 document 리스너·오버레이를 걷는다
  const mountedRef = useRef(true);
  const bulkBusyRef = useRef(false);
  const listSeqRef = useRef(0);
  const detailSeqRef = useRef(0);
  const contextSeqRef = useRef(0);

  // 내 정보·회차·부서(활성만). 처음(initial)과 회차 관리의 쓰기 뒤(D5b)에 부른다 — 늦게 온 앞 응답은 버린다.
  //   회차 기본값 = 접수 중인 회차(me.open_round), 없으면 첫 항목(번호가 큰 것부터 온다).
  //   🔴 다시 읽을 때 사용자가 고른 회차(roundId)는 바꾸지 않는다 — 고른 회차가 아직 없을 때만 기본값을 고른다.
  const loadContext = (initial) => {
    const seq = contextSeqRef.current + 1;
    contextSeqRef.current = seq;
    const isCurrent = () => mountedRef.current && contextSeqRef.current === seq;
    const mePromise = devreqAPI.me().then((r) => r?.data || null, () => null);
    const roundsPromise = devreqAPI.rounds().then((r) => (Array.isArray(r?.data) ? r.data : []), () => null);
    devreqAPI.departments()
      .then((r) => { if (isCurrent()) setDepartments(Array.isArray(r?.data) ? r.data : []); })
      .catch(() => {});
    return Promise.all([mePromise, roundsPromise]).then(([meData, roundList]) => {
      if (!isCurrent()) return;
      // 다시 읽기가 실패하면 앞 값을 그대로 둔다.
      if (initial || meData) setMe(meData);
      if (roundList === null) {
        // 회차를 못 읽으면 서버가 고르는 회차(열린 회차 → 최근)로 목록만 읽는다.
        if (initial) setRoundsState('failed');
        return;
      }
      setRounds(roundList);
      const openId = meData?.open_round?.id;
      const pick = roundList.some((r) => r.id === openId) ? openId : roundList[0]?.id;
      const fallback = pick === undefined || pick === null ? '' : String(pick);
      setRoundId((prev) => (prev && roundList.some((r) => String(r.id) === prev) ? prev : fallback));
      setRoundsState('ready');
    });
  };
  // 회차 관리(DevRequestAdmin)의 쓰기 뒤 — 회차 고르기 · «+ 새 요청»(me.open_round·me.departments) · 목록(이월로 바뀔 수 있다).
  //   🔴 목록은 회차를 다시 읽은 «뒤에» 부른다 — 먼저 부르면 방금 지운 회차 id 로 요청이 나가 404 가 한 번 난다(D8 e2e 10-17).
  //   finally — 회차 읽기가 실패해도(앞 값 유지) 목록은 다시 읽는다(이월로 목록이 바뀔 수 있다).
  const refreshContext = () => {
    loadContext(false).finally(() => {
      if (mountedRef.current) setListVersion((v) => v + 1);
    });
  };

  useEffect(() => {
    mountedRef.current = true;
    loadContext(true);
    return () => {
      mountedRef.current = false;
      listSeqRef.current += 1;     // 화면을 떠난 뒤 온 응답은 버린다
      detailSeqRef.current += 1;
      contextSeqRef.current += 1;
    };
  }, []);

  // 검색 — 입력 후 300ms(또는 Enter 즉시).
  useEffect(() => {
    const timer = setTimeout(() => setQ(qInput.trim()), SEARCH_DELAY_MS);
    return () => clearTimeout(timer);
  }, [qInput]);

  // 목록 — 회차·필터·검색만 params 로 보낸다(이월 건은 서버가 그 회차 행으로 옮겨 둔 것이라 따로 묻지 않는다).
  useEffect(() => {
    if (roundsState === 'loading') return;
    if (roundsState === 'ready' && !roundId) {   // 회차가 하나도 없다
      setData(null);
      setBusy(false);
      return;
    }
    const seq = listSeqRef.current + 1;
    listSeqRef.current = seq;
    const isCurrent = () => mountedRef.current && listSeqRef.current === seq;
    const params = {};
    if (roundId) params.round_id = Number(roundId);
    if (deptId) params.dept_id = Number(deptId);
    if (decision) params.decision = decision;
    if (status) params.status = status;
    if (mine) params.mine = true;
    if (q) params.q = q;
    // 목록 열쇠 — 이 응답을 부른 params. 🔴 지금 상태로 계산하지 않는다(새로 부르는 동안 «새 필터 + 옛 목록»으로 한 번 그려진다).
    const listKey = JSON.stringify(params);
    setBusy(true);
    setError('');
    devreqAPI.list(params)
      .then((r) => {
        if (!isCurrent()) return;
        const nextItems = Array.isArray(r?.data?.items) ? r.data.items : [];
        setData({
          items: nextItems,
          total: Number(r?.data?.total) || 0,
          round: r?.data?.round || null,
          key: listKey,
        });
        // 일괄 상태로 고른 것은 새 목록에 있는 것만 남긴다 — 필터를 되돌렸을 때 예전 선택이 다시 살아나지 않게.
        const ids = new Set(nextItems.map((it) => it.id));
        setSelected((prev) => {
          const kept = [...prev].filter((id) => ids.has(id));
          return kept.length === prev.size ? prev : new Set(kept);
        });
      })
      .catch((err) => {
        if (!isCurrent()) return;
        setData(null);
        setSelected(new Set());
        setError(errorText(err, '목록을 불러오지 못했습니다.'));
      })
      .finally(() => { if (isCurrent()) setBusy(false); });
  }, [roundsState, roundId, deptId, decision, status, mine, q, listVersion]);

  // 상세 — 주소의 ?id= 가 정본이다(알림 링크 /dev-requests?id=<id> 로 바로 열린다).
  useEffect(() => {
    const seq = detailSeqRef.current + 1;
    detailSeqRef.current = seq;
    if (selectedId === null) {
      setDetail({ item: null, loading: false, error: '' });
      return;
    }
    const isCurrent = () => mountedRef.current && detailSeqRef.current === seq;
    setDetail({ item: null, loading: true, error: '' });
    devreqAPI.get(selectedId)
      .then((r) => { if (isCurrent()) setDetail({ item: r?.data || null, loading: false, error: '' }); })
      .catch((err) => { if (isCurrent()) setDetail({ item: null, loading: false, error: errorText(err, '요청을 불러오지 못했습니다.') }); });
  }, [selectedId]);

  // 주소의 다른 값(?tab=)은 그대로 두고 ?id= 만 바꾼다.
  const withParams = (change) => {
    const params = new URLSearchParams(searchParams);
    change(params);
    setSearchParams(params);
  };
  const openRequest = (id) => withParams((params) => params.set('id', String(id)));
  const closeDetail = () => withParams((params) => params.delete('id'));
  const applySearch = () => setQ(qInput.trim());

  // 탭 — ?tab=dashboard · ?tab=admin(AX 가 아니면 목록) · 그 밖은 목록. 탭을 바꾸면 열린 상세는 닫는다.
  const isAx = me?.is_ax === true;
  const rawTab = searchParams.get('tab') || '';
  const tab = rawTab === TAB_DASHBOARD.key ? TAB_DASHBOARD.key : (rawTab === TAB_ADMIN.key && isAx ? TAB_ADMIN.key : TAB_LIST.key);
  const tabs = isAx ? [TAB_LIST, TAB_DASHBOARD, TAB_ADMIN] : [TAB_LIST, TAB_DASHBOARD];
  const changeTab = (next) => withParams((params) => {
    params.delete('id');
    if (next === TAB_LIST.key) params.delete('tab');
    else params.set('tab', next);
  });

  // 쓰기 뒤 상세를 다시 읽는다 — 지금 보이는 내용은 그대로 두고 바꿔 끼운다(첨부·메모 묶음이 깜빡이지 않게).
  const refreshDetail = (id) => {
    const seq = detailSeqRef.current + 1;
    detailSeqRef.current = seq;
    const isCurrent = () => mountedRef.current && detailSeqRef.current === seq;
    devreqAPI.get(id)
      .then((r) => { if (isCurrent()) setDetail({ item: r?.data || null, loading: false, error: '' }); })
      .catch((err) => { if (isCurrent()) setDetail((prev) => ({ ...prev, loading: false, error: errorText(err, '요청을 불러오지 못했습니다.') })); });
  };
  // 저장 직전 이웃을 지금 요청에 고정한다 — 저장으로 정렬 자리가 바뀌어도 차례로 검토하던 «이전 / 다음»이 끊기지 않게.
  //   (같은 목록 열쇠일 때만 쓰고 · 다른 요청을 열거나 열쇠가 바뀌면 지운다 — 이웃 계산 참고.)
  const pinNav = () => {
    const cur = navRef.current;
    if (!cur || cur.id === null || cur.id !== selectedId || cur.key === null) return;
    pinnedNavRef.current = { id: cur.id, prevId: cur.prevId, nextId: cur.nextId, key: cur.key };
  };
  // opts.pinNav — 상세에서 저장한 경우만(일괄 상태·순위 저장은 상세에서 차례로 검토하는 흐름이 아니라 고정하지 않는다).
  const afterChange = (opts) => {
    if (opts?.pinNav) pinNav();
    setListVersion((v) => v + 1);
    if (selectedId !== null) refreshDetail(selectedId);
  };
  // 저장하면 목록을 다시 부르고 그 요청 상세를 연다(고치기는 지금 상세를 다시 읽는다).
  const onFormSaved = (saved) => {
    setForm(null);
    const id = saved?.id;
    if (id !== undefined && id !== null && id === selectedId) pinNav();
    setListVersion((v) => v + 1);
    if (id === undefined || id === null) return;
    if (id === selectedId) refreshDetail(id);
    else openRequest(id);
  };
  const onRankSaved = () => {
    setRankOpen(false);
    afterChange();
  };
  const roundById = (id) => rounds.find((r) => r.id === id)
    || (data?.round?.id === id ? data.round : null)
    || (me?.open_round?.id === id ? me.open_round : null);

  const myDepartments = Array.isArray(me?.departments) ? me.departments : [];
  // 목록 위 단추 — 접수 중인 회차가 있고 내 부서가 있을 때만(/me). 부서가 비면 안내 한 줄(AX 는 문의할 곳이 자기라 안내 없음).
  const canWrite = !!me?.open_round && myDepartments.length > 0;
  const noDepartment = !!me && myDepartments.length === 0 && !isAx;

  // 내 부서 행 표시용(권한 판정 아님).
  const myDeptIds = new Set(myDepartments.map((d) => d.id));
  const items = data?.items || [];
  const total = data?.total || 0;
  const pickedRound = rounds.find((r) => String(r.id) === roundId);
  const currentRound = pickedRound || data?.round || null;
  const noRounds = roundsState === 'ready' && rounds.length === 0;
  const detailOpen = selectedId !== null;
  const columns = detailOpen ? COMPACT_HEADERS : HEADERS;
  // 크게 보기 — 넓은 화면에서 상세를 열었을 때만. 목록 상태(필터·정렬·검색·선택·data)는 이 부모에 있어 접어도 그대로다.
  const expandedOn = expanded && !isMobile && detailOpen;
  const toggleExpanded = () => {
    const next = !expanded;
    setExpanded(next);
    try {
      if (next) window.localStorage.setItem(DETAIL_EXPANDED_KEY, '1');
      else window.localStorage.removeItem(DETAIL_EXPANDED_KEY);
    } catch (err) { /* 저장 실패는 무시 */ }
  };
  useEffect(() => {
    if (selectedId !== null) lastOpenedIdRef.current = selectedId;
  }, [selectedId]);
  // 크게 보기 → 목록 함께 보기(또는 크게 보기에서 «닫기») — 목록 상자가 새로 그려지므로 마지막으로 본 행을 화면 안으로.
  useEffect(() => {
    const was = wasExpandedRef.current;
    wasExpandedRef.current = expandedOn;
    if (!was || expandedOn) return;
    const id = lastOpenedIdRef.current;
    const row = id === null ? null : mainRef.current?.querySelector(`[data-req-id="${id}"]`);
    if (row && typeof row.scrollIntoView === 'function') row.scrollIntoView({ block: 'nearest' });
  }, [expandedOn]);

  // 표 머리 정렬 — 표 행·휴대폰 카드만 이 순서로 그린다(선택·전체 선택은 id 기준이라 items 그대로).
  //   필터·회차를 바꿔도 · 상세를 열어 간단 열이 돼도 정렬은 그대로(숨은 열 기준이면 화살표만 안 보인다).
  const sortedItems = useMemo(
    () => (sort.key ? [...items].sort(compareBy(sort.key, sort.dir)) : items),
    [items, sort],
  );
  // 같은 머리 = 오름 → 내림 → 해제 · 다른 머리 = 그 머리 오름부터.
  const cycleSort = (h) => setSort((prev) => {
    if (prev.key !== h) return { key: h, dir: 'asc' };
    if (prev.dir === 'asc') return { key: h, dir: 'desc' };
    return { key: null, dir: null };
  });

  // «이전 / 다음» — 화면에 그린 순서(sortedItems)의 옆 요청 · 끝이면 null(감싸 돌지 않는다).
  //   열쇠 = 그 목록을 부른 params(data.key) + 그리는 정렬. 지금 요청이 목록에 없으면:
  //   같은 열쇠에서 방금까지 있었다(저장 뒤 필터에서 빠짐) → 빠진 자리로 당겨진 행 기준 · 그 밖(필터를 바꿈 · 처음부터 없음) → 둘 다 null.
  //   상세에서 저장했으면(pinnedNavRef) 같은 요청·같은 열쇠인 동안 저장 직전 이웃을 그대로 쓴다 — null 은 null 그대로,
  //   그 id 가 새 목록에서 사라졌을 때만 새 자리로 계산한다(그래서 라벨과 단추가 화면 순서와 잠깐 다를 수 있다 · 의도).
  const navKey = data ? `${data.key}|${sort.key || ''}|${sort.dir || ''}` : null;
  const nav = useMemo(() => {
    const len = sortedItems.length;
    const pos = selectedId === null ? -1 : sortedItems.findIndex((it) => it.id === selectedId);
    const last = lastPosRef.current;
    if (pos >= 0) lastPosRef.current = { id: selectedId, pos, key: navKey };
    const gap = pos < 0 && last && last.id === selectedId && last.key === navKey ? last.pos : null;
    let prevId = null;
    let nextId = null;
    if (pos >= 0) {
      prevId = pos > 0 ? sortedItems[pos - 1].id : null;
      nextId = pos < len - 1 ? sortedItems[pos + 1].id : null;
    } else if (gap !== null) {
      prevId = gap > 0 && gap - 1 < len ? sortedItems[gap - 1].id : null;
      nextId = gap < len ? sortedItems[gap].id : null;
    }
    const pin = pinnedNavRef.current;
    if (pin && (pin.id !== selectedId || pin.key !== navKey)) {
      pinnedNavRef.current = null;
    } else if (pin) {
      const ids = new Set(sortedItems.map((it) => it.id));
      const pinned = (id, fallback) => {
        if (id === null) return null;
        return ids.has(id) ? id : fallback;
      };
      prevId = pinned(pin.prevId, prevId);
      nextId = pinned(pin.nextId, nextId);
    }
    return { id: selectedId, prevId, nextId, label: pos >= 0 ? `${pos + 1} / ${len}` : null, key: navKey };
  }, [sortedItems, selectedId, navKey]);
  navRef.current = nav;
  const detailNav = {
    onPrev: nav.prevId === null ? null : () => openRequest(nav.prevId),
    onNext: nav.nextId === null ? null : () => openRequest(nav.nextId),
    label: nav.label,
  };

  // 상세 패널 폭 — 화면 표시값(저장값은 덮지 않는다).
  const detailShownW = clampDetailW(detailW, mainW);
  // main ref — 붙는 즉시 폭을 재고 ResizeObserver 로 창 크기·메인 사이드바 폭/접기·분할보기 변화를 따라간다
  // (MeetingsPage setPanelRowNode 와 같은 방식). 🔴 window resize 로 대신하지 않는다 — 사이드바·분할보기 변화를 못 잡는다.
  const setMainNode = useCallback((node) => {
    mainRef.current = node;
    if (mainRoRef.current) {
      mainRoRef.current.disconnect();
      mainRoRef.current = null;
    }
    if (!node) {
      setMainW(0);
      return;
    }
    // 웹 배율(<html> zoom)이 걸리면 rect 는 화면 px, 폭 style 은 CSS px 다 → main 의 배율로 나눠 CSS px 로 든다(jsdom·1.0 은 1).
    const measure = () => {
      const w = node.getBoundingClientRect?.().width;
      setMainW(Number.isFinite(w) && w > 0 ? Math.round(w / scaleOf(w, node.offsetWidth)) : 0);
    };
    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(measure);
      ro.observe(node);
      mainRoRef.current = ro;
    }
    measure();   // 🔴 관찰을 걸고 바로 한 번 잰다 — RO 의 첫 전달을 기다리면 한 프레임이 제한 없이 나간다.
  }, []);
  // 끄는 도중 언마운트 · 상세 닫힘 · 휴대폰 전환 · 크게 보기 = 그 자리에서 끌기를 마친다(손잡이만 사라지고 리스너가 남지 않게).
  useEffect(() => () => { if (detailDragCleanupRef.current) detailDragCleanupRef.current(); }, [detailOpen, isMobile, expandedOn]);
  // 경계 끌기 — 왼쪽으로 끌수록 상세가 넓어진다(폭 = 시작 폭 − 이동량) · [360, min(1200, main−420)].
  // 🔴 오버레이는 3px 이상 움직여 진짜 끌기가 됐을 때만 붙인다 — mousedown 순간 붙이면 mouseup 대상이 손잡이가 아니게 돼
  //    실제 브라우저에서 손잡이 dblclick(기본 폭 복귀)이 오지 않는다(MeetingsPage startFolderPanelDrag 와 같은 이유).
  // 저장은 끌기를 마칠 때 한 번 — 클릭·더블클릭(움직임 없음)은 저장하지 않는다.
  // 웹 배율(<html> zoom)이 걸리면 clientX·rect 는 화면 px, 폭은 CSS px 다 → 이동량·main 폭을 main 의 배율로 나눈다(jsdom·1.0 은 1).
  //   3px 끌기 판정은 화면 px 그대로 둔다(클릭·더블클릭 판정이 배율 따라 바뀌지 않게).
  const startDetailDrag = (e) => {
    if (e.button !== 0) return;
    e.preventDefault();   // 글자 선택 시작 방지
    if (detailDragCleanupRef.current) detailDragCleanupRef.current();
    const startX = e.clientX;
    const startW = detailShownW;
    const main = mainRef.current;
    const mr = main?.getBoundingClientRect?.();
    const s = mr ? scaleOf(mr.width, main.offsetWidth) : 1;
    const rowW = mr?.width ? mr.width / s : mainW;
    const body = document.body;
    let moved = false;
    let ov = null;
    let last = startW;
    const onMove = (ev) => {
      const rawDx = ev.clientX - startX;
      if (!moved) {
        if (Math.abs(rawDx) < 3) return;
        moved = true;
        ov = document.createElement('div');
        ov.setAttribute('data-testid', 'devreq-detail-resize-overlay');
        ov.style.cssText = 'position:fixed;inset:0;z-index:99999;cursor:col-resize';
        body.appendChild(ov);
      }
      last = clampDetailW(startW - rawDx / s, rowW);
      setDetailW(last);
    };
    const onUp = () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
      body.style.userSelect = '';
      body.style.cursor = '';
      if (ov && ov.parentNode) ov.parentNode.removeChild(ov);
      ov = null;
      if (detailDragCleanupRef.current === onUp) detailDragCleanupRef.current = null;
      if (moved) {
        moved = false;
        try { window.localStorage.setItem(DETAIL_W_KEY, String(last)); } catch (err) { /* 저장 실패는 무시 */ }
      }
    };
    detailDragCleanupRef.current = onUp;
    body.style.userSelect = 'none';
    body.style.cursor = 'col-resize';
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  };
  // 더블클릭·Home = 기본 폭(460) · 저장값 없음. 두 번째 mouseup 은 움직임이 없어 저장하지 않으므로 이 값이 마지막에 남는다.
  const resetDetailW = () => {
    setDetailW(DETAIL_W_DEFAULT);
    try { window.localStorage.removeItem(DETAIL_W_KEY); } catch (err) { /* 저장소 접근 불가 시 무시 */ }
  };
  // 키보드(손잡이 초점) — ← 넓게 · → 좁게(한 번 16px · 잘라서 저장) · Home = 기본 폭.
  const onDetailResizerKey = (e) => {
    if (e.key === 'Home') {
      e.preventDefault();
      resetDetailW();
      return;
    }
    let step = 0;
    if (e.key === 'ArrowLeft') step = DETAIL_W_STEP;
    else if (e.key === 'ArrowRight') step = -DETAIL_W_STEP;
    if (!step) return;
    e.preventDefault();
    // main 폭은 끌기와 같이 화면 px ÷ 배율 = CSS px 로 쓴다(jsdom·1.0 은 1).
    const main = mainRef.current;
    const mr = main?.getBoundingClientRect?.();
    const rowW = mr?.width ? mr.width / scaleOf(mr.width, main.offsetWidth) : mainW;
    const next = clampDetailW(detailShownW + step, rowW);
    setDetailW(next);
    try { window.localStorage.setItem(DETAIL_W_KEY, String(next)); } catch (err) { /* 저장 실패는 무시 */ }
  };

  // 빈 목록 안내 — 필터(회차 제외 · 검색은 목록 요청에 실제로 쓰인 q)가 걸렸으면 그 말 · 접수 중 회차를 보고 새 요청을 낼 수 있으면 첫 요청 안내.
  const filtered = deptId !== '' || decision !== '' || status !== '' || mine || q !== '';
  let emptyText = EMPTY_DEFAULT;
  if (filtered) emptyText = EMPTY_FILTERED;
  else if (canWrite && roundId === String(me.open_round.id)) emptyText = EMPTY_FIRST;

  // 일괄 상태(AX · 표에서만 · 휴대폰 제외) — 고른 것 중 지금 목록에 있는 것만(전체 선택도 지금 목록만).
  //   휴대폰 카드는 카드 전체가 «상세 열기» 단추라 체크를 넣지 않는다 — 여러 건 일괄은 넓은 화면의 표에서 한다.
  const bulkOn = isAx && !isMobile;
  const selectedIds = bulkOn ? items.filter((it) => selected.has(it.id)).map((it) => it.id) : [];
  const allSelected = items.length > 0 && selectedIds.length === items.length;
  const toggleOne = (id) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
    setBulkError(null);
  };
  const toggleAll = () => {
    setSelected(allSelected ? new Set() : new Set(items.map((it) => it.id)));
    setBulkError(null);
  };
  const applyBulk = async () => {
    if (bulkBusyRef.current || !bulkStatus || selectedIds.length === 0) return;
    bulkBusyRef.current = true;
    setBulkBusy(true);
    setBulkError(null);
    try {
      await devreqAPI.bulkStatus(selectedIds, bulkStatus);
      if (!mountedRef.current) return;
      setSelected(new Set());
      setBulkStatus('');
      afterChange();
    } catch (err) {
      if (mountedRef.current) setBulkError(bulkErrorOf(err));
    } finally {
      bulkBusyRef.current = false;
      if (mountedRef.current) setBulkBusy(false);
    }
  };
  const headers = bulkOn ? ['', ...columns] : columns;

  // 추가 요청 배지 — 서버 값으로만(답할 사람 = 행의 can.answer_ask · AX 에게는 열린 추가 요청 = open_ask).
  const askBadge = (it) => {
    if (it.can?.answer_ask === true) return <span style={ANSWER_NEEDED_BADGE}>답 필요</span>;
    if (isAx && it.open_ask === true) return <span style={ANSWER_WAITING_BADGE}>답 대기</span>;
    return null;
  };
  // AI 1차 판독 배지(AX 만 · 서버도 AX 가 아니면 null) — 열을 늘리지 않고 제목 칸에 붙인다.
  //   주황 TONES 는 쓰지 않는다(f11 시험) — 주의 = 이월 배지와 같은 노랑 · 실패 = 빨강 · 통과·자동 반려 = 회색.
  //   정했거나 철회한 요청에는 주의 배지를 남기지 않는다(aiScreenView 의 muted).
  const aiBadge = (it) => {
    const view = isAx ? aiScreenView(it) : null;
    if (!view || view.muted) return null;
    return <span style={smallBadge(...view.colors)}>{view.label}</span>;
  };

  // 상세를 연 동안(detailOpen)은 간단 열 — 요청번호·제목·상태 칸만(머리 columns 와 같은 기준).
  const renderRow = (it) => {
    const mineRow = myDeptIds.has(it.dept_id);
    return (
      <tr key={it.id} className="gw-tr" data-testid="devreq-row" data-req-id={it.id} onClick={() => openRequest(it.id)}
        style={{ cursor: 'pointer', opacity: it.withdrawn ? 0.5 : 1, background: selectedId === it.id ? '#f8fafc' : undefined }}>
        {bulkOn && (
          // 체크는 상세를 열지 않는다.
          <td style={td} onClick={(e) => e.stopPropagation()}>
            <input type="checkbox" aria-label={`${text(it.req_no)} 선택`} checked={selected.has(it.id)} onChange={() => toggleOne(it.id)} />
          </td>
        )}
        <td style={{ ...td, color: COLORS.text, background: mineRow ? MINE_BG : undefined }}>
          <span>{text(it.req_no)}</span>
          {it.carried && <> <span style={CARRIED_BADGE}>{carriedLabel(it)}</span></>}
        </td>
        {!detailOpen && (
          <>
            <td style={td}>{text(it.dept_name)}</td>
            <td style={td}>{text(it.dept_rank)}</td>
          </>
        )}
        <td style={{ ...td, whiteSpace: 'normal', minWidth: '200px', color: it.masked ? COLORS.textSub : COLORS.text }}>
          {titleOf(it)}
          {askBadge(it) && <> {askBadge(it)}</>}
          {aiBadge(it) && <> {aiBadge(it)}</>}
        </td>
        {!detailOpen && (
          <>
            <td style={td}>{text(it.requester_name)}</td>
            <td style={td}>{text(it.assignee_name)}</td>
            <td style={td}>
              {it.decision ? <span style={decisionBadge(it.decision)}>{it.decision}</span> : '—'}
              {it.decision === '통합' && it.merged_into_req_no && <span style={{ marginLeft: '4px', fontSize: '12px' }}>→ {it.merged_into_req_no}</span>}
            </td>
            <td style={td}>{text(it.priority)}</td>
            <td style={td}>{fmtDay(it.plan_end)}</td>
            <td style={td}>{fmtDay(it.dev_started_on)}</td>
            <td style={td}>{fmtDay(actualDoneOn(it))}</td>
          </>
        )}
        <td style={td}>
          {it.status ? <span style={statusBadge(it.status)}>{it.status}</span> : '—'}
          {it.withdrawn && <> <span style={WITHDRAWN_BADGE}>철회</span></>}
        </td>
        {!detailOpen && <td style={td}>{text(it.confirm_state)}</td>}
      </tr>
    );
  };

  // 휴대폰 카드 — 번호·부서·제목·상태 배지.
  const renderCard = (it) => {
    const mineRow = myDeptIds.has(it.dept_id);
    return (
      <li key={it.id} style={{ listStyle: 'none' }}>
        <button type="button" data-testid="devreq-card" data-req-id={it.id} onClick={() => openRequest(it.id)}
          style={{ display: 'block', width: '100%', boxSizing: 'border-box', textAlign: 'left', padding: '10px 12px', marginBottom: '8px', cursor: 'pointer',
            border: `1px solid ${COLORS.border}`, borderLeft: `4px solid ${mineRow ? COLORS.primaryBorder : COLORS.border}`, borderRadius: '10px',
            background: COLORS.surface, opacity: it.withdrawn ? 0.5 : 1, minWidth: 0 }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px', fontSize: '12px', color: COLORS.textSub }}>
            <span style={{ fontWeight: 700, color: COLORS.text }}>{text(it.req_no)}</span>
            {it.carried && <span style={CARRIED_BADGE}>{carriedLabel(it)}</span>}
            <span>{text(it.dept_name)}</span>
            <span style={{ marginLeft: 'auto', display: 'inline-flex', gap: '4px' }}>
              {it.withdrawn && <span style={WITHDRAWN_BADGE}>철회</span>}
              {it.status && <span style={statusBadge(it.status)}>{it.status}</span>}
            </span>
          </div>
          <div style={{ marginTop: '6px', fontSize: '14px', color: it.masked ? COLORS.textSub : COLORS.text, overflowWrap: 'anywhere' }}>
            {titleOf(it)}
            {askBadge(it) && <> {askBadge(it)}</>}
            {aiBadge(it) && <> {aiBadge(it)}</>}
          </div>
        </button>
      </li>
    );
  };

  // 위아래 여백 0 — 높이 30 에 input 의 여백 7 이 남으면 글자 아래가 잘린다(ROUND_SELECT_WIDE 와 같은 까닭).
  const fieldWidth = (w) => (isMobile ? { ...input, padding: '0 10px', width: '100%', height: '30px' } : { ...input, padding: '0 10px', width: w, height: '30px' });

  const roundBadgeOn = !!currentRound && tab !== TAB_ADMIN.key;
  const loadingOn = busy && tab === TAB_LIST.key;
  const headActions = (roundBadgeOn || loadingOn) ? (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px' }}>
      {roundBadgeOn && <span style={roundStatusBadge(currentRound.status)}>{roundStatusLabel(currentRound.status)}</span>}
      {loadingOn && <span role="status" style={{ color: COLORS.textMuted, fontSize: '12px', whiteSpace: 'nowrap' }}>불러오는 중…</span>}
    </div>
  ) : null;

  return (
    <AppShell app="devreq">
      <main ref={setMainNode} style={{ flex: 1, minWidth: 0, height: 'var(--gw-app-h, 100dvh)', display: 'flex', overflow: 'hidden', background: COLORS.bg }}>
        {/* 크게 보기 = 목록 상자를 이 자리에서 뺀다. 🔴 갈래(목록+상세 / 상세만)로 나누지 않는다 — 상세가 같은 부모·같은 자리에
            남아야 고치던 값(② 검토 편집 등)이 그대로다. */}
        {!expandedOn && (
        <div style={{ flex: 1, minWidth: 0, overflowY: 'auto', overflowX: 'hidden' }}>
          <Page>
            <PageHeader icon={IconClipboardList} tone="yellow" title="개발요청" actions={headActions} />

            <PillTabs ariaLabel="개발요청 보기" idBase="devreq-view" value={tab} onChange={changeTab} items={tabs.map((t) => ({ key: t.key, label: t.label }))} />

            <div role="tabpanel" id={`devreq-view-panel-${tab}`} aria-labelledby={`devreq-view-tab-${tab}`}>
              {roundsState === 'failed' && tab !== TAB_ADMIN.key && (
                <div role="alert" style={{ ...card, background: COLORS.dangerSoft, color: COLORS.dangerText, marginBottom: '12px' }}>회차 목록을 불러오지 못했습니다.</div>
              )}

              {tab === TAB_DASHBOARD.key && (
                <DevRequestDashboard rounds={rounds} roundId={roundId} onRoundChange={setRoundId}
                  ready={roundsState !== 'loading'} isMobile={isMobile} />
              )}
              {tab === TAB_ADMIN.key && <DevRequestAdmin isMobile={isMobile} onChanged={refreshContext} />}

              {tab !== TAB_LIST.key ? null : noRounds ? (
                <div style={{ ...card, color: COLORS.textMuted, textAlign: 'center', padding: '32px 16px' }}>아직 열린 회차가 없습니다</div>
              ) : (
                <>
                  {canWrite && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '12px' }}>
                      <button type="button" onClick={() => setForm({ mode: 'create' })} style={btn('primary', 'sm')}>+ 새 요청</button>
                      <button type="button" onClick={() => setRankOpen(true)} style={btn('secondary', 'sm')}>부서 순위 정렬</button>
                    </div>
                  )}
                  {noDepartment && (
                    <div style={{ ...card, padding: '10px 14px', marginBottom: '12px', color: COLORS.textSub, fontSize: '13px' }}>
                      부서가 연결되지 않아 요청을 낼 수 없습니다 — AX에 문의해 주세요
                    </div>
                  )}
                  <section aria-label="개발요청 검색 조건" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center', marginBottom: '16px' }}>
                    {rounds.length > 0 && (
                      <select aria-label="회차" value={roundId} onChange={(e) => setRoundId(e.target.value)}
                        title={pickedRound ? roundOptionText(pickedRound) : undefined}
                        style={isMobile ? fieldWidth('100%') : ROUND_SELECT_WIDE}>
                        {rounds.map((r) => <option key={r.id} value={String(r.id)}>{roundOptionText(r)}</option>)}
                      </select>
                    )}
                    <select aria-label="부서" value={deptId} onChange={(e) => setDeptId(e.target.value)} style={fieldWidth('150px')}>
                      <option value="">부서 전체</option>
                      {departments.map((d) => <option key={d.id} value={String(d.id)}>{d.name}</option>)}
                    </select>
                    <select aria-label="진행 여부" value={decision} onChange={(e) => setDecision(e.target.value)} style={fieldWidth('130px')}>
                      <option value="">진행 여부 전체</option>
                      {DECISIONS.map((v) => <option key={v} value={v}>{v}</option>)}
                    </select>
                    <select aria-label="상태" value={status} onChange={(e) => setStatus(e.target.value)} style={fieldWidth('130px')}>
                      <option value="">상태 전체</option>
                      {STATUSES.map((v) => <option key={v} value={v}>{v}</option>)}
                    </select>
                    <label style={{ fontSize: '12px', color: COLORS.textSub, display: 'inline-flex', alignItems: 'center', gap: '4px', whiteSpace: 'nowrap' }}>
                      <input type="checkbox" checked={mine} onChange={(e) => setMine(e.target.checked)} />내 부서만
                    </label>
                    {/* 돋보기 상자 — 공용 SearchInput 은 type="text"(역할 textbox)라 쓰지 않는다(시험이 searchbox «검색» 으로 찾는다).
                        안쪽 input 에 outline 을 넣지 않는다 — 전역 초점 테두리를 지우면 키보드 초점이 안 보인다. */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '7px', height: '30px', padding: '0 9px', boxSizing: 'border-box',
                      border: `1px solid ${COLORS.inputBorder}`, borderRadius: '5px', background: COLORS.surface, width: isMobile ? '100%' : '220px', maxWidth: '100%' }}>
                      <IconSearch size={14} stroke={ICON_STROKE} aria-hidden="true" style={{ color: COLORS.textMuted, flexShrink: 0 }} />
                      <input type="search" aria-label="검색" placeholder="요청번호·제목·내용" value={qInput}
                        onChange={(e) => setQInput(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); applySearch(); } }}
                        style={{ border: 0, background: 'transparent', flex: 1, minWidth: 0, width: '100%', fontSize: '13px', color: COLORS.text }} />
                    </div>
                    {!isMobile && <button type="button" onClick={applySearch} style={btn('primary', 'sm')}>검색</button>}
                  </section>

                  {error && <div role="alert" style={{ ...card, background: COLORS.dangerSoft, color: COLORS.dangerText, marginBottom: '12px' }}>{error}</div>}

                  {selectedIds.length > 0 && (
                    <section aria-label="상태 일괄 변경" style={{ ...card, padding: '10px 14px', marginBottom: '12px' }}>
                      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px', fontSize: '13px' }}>
                        <span style={{ fontWeight: 700 }}>{`${selectedIds.length}건 선택`}</span>
                        <span>상태 일괄 변경</span>
                        <select aria-label="일괄 변경할 상태" value={bulkStatus} onChange={(e) => setBulkStatus(e.target.value)} style={fieldWidth('140px')}>
                          <option value="">상태 고르기</option>
                          {STATUSES.map((v) => <option key={v} value={v}>{v}</option>)}
                        </select>
                        <button type="button" onClick={applyBulk} disabled={!bulkStatus || bulkBusy}
                          style={{ ...btn('primary', 'sm'), opacity: !bulkStatus || bulkBusy ? 0.5 : 1 }}>적용</button>
                      </div>
                      {bulkError && (
                        <div role="alert" style={{ marginTop: '8px', padding: '8px 12px', borderRadius: '8px', background: COLORS.dangerSoft, color: COLORS.dangerText, fontSize: '13px' }}>
                          <div>{bulkError.message}</div>
                          {bulkError.blocked.length > 0 && (
                            <>
                              <div style={{ marginTop: '6px', fontWeight: 700 }}>걸린 요청번호</div>
                              <ul aria-label="걸린 요청번호" style={{ margin: '4px 0 0', paddingLeft: '18px' }}>
                                {bulkError.blocked.map((b, i) => (
                                  <li key={`${b.reqNo}-${i}`} style={{ overflowWrap: 'anywhere' }}>{b.reason ? `${b.reqNo} — ${b.reason}` : b.reqNo}</li>
                                ))}
                              </ul>
                            </>
                          )}
                        </div>
                      )}
                    </section>
                  )}

                  {isMobile ? (
                    <section aria-label="개발요청 목록">
                      <ul style={{ margin: 0, padding: 0 }}>{sortedItems.map(renderCard)}</ul>
                      {data && !error && items.length === 0 && (
                        <div style={{ ...card, color: COLORS.textMuted, textAlign: 'center', padding: '24px' }}>{emptyText}</div>
                      )}
                      <div style={{ padding: '6px 2px', fontSize: '12px', color: COLORS.textSub }}>총 {total.toLocaleString()}건</div>
                    </section>
                  ) : (
                    <section>
                      {/* 머리 정렬 단추 기본 모양은 인라인 리셋으로 지우고 outline·밑줄은 인라인에 두지 않는다 —
                          인라인이 :hover·:focus-visible 규칙을 이기기 때문(인라인 all:unset 이 그래서 둘 다 지웠다).
                          마우스 올림·키보드 초점에는 밑줄로 «누를 수 있다»를 알린다. */}
                      <style>{`.gw-devreq-sort:focus-visible{outline:2px solid ${COLORS.info};outline-offset:2px}`
                        + '.gw-devreq-sort:hover,.gw-devreq-sort:focus-visible{text-decoration:underline;text-underline-offset:3px}'}</style>
                      <div style={{ overflowX: 'auto' }}>
                        <table aria-label="개발요청 목록" style={{ width: '100%', borderCollapse: 'collapse', ...(detailOpen ? {} : { minWidth: TABLE_MIN_W }) }}>
                          <thead>
                            <tr>
                              {bulkOn && (
                                <th style={{ ...th, width: '32px' }}>
                                  <input type="checkbox" aria-label="전체 선택" checked={allSelected} disabled={items.length === 0} onChange={toggleAll} />
                                </th>
                              )}
                              {/* 🔴 머리 글자 뒤에는 늘 표시 한 칸(aria-hidden) — 정렬 안 됨 = 연한 « ↕» · 정렬한 머리 = 진한 « ▲»/« ▼»
                                  (정렬한 머리의 글자는 «머리 ▲» 그대로 — e2e 가 정확 비교한다). 간단 열도 같다. */}
                              {columns.map((h) => {
                                const on = sort.key === h;
                                let hint = SORT_HINT;
                                if (on) hint = sort.dir === 'asc' ? ' ▲' : ' ▼';
                                return (
                                  <th key={h} style={th} aria-sort={on ? (sort.dir === 'asc' ? 'ascending' : 'descending') : 'none'}>
                                    <button type="button" className="gw-devreq-sort" onClick={() => cycleSort(h)} title={`${h} 기준 정렬`}
                                      style={{ appearance: 'none', background: 'none', border: 0, padding: 0, margin: 0,
                                               font: 'inherit', color: 'inherit', textAlign: 'inherit', letterSpacing: 'inherit',
                                               cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '3px' }}>
                                      {h}<span aria-hidden="true" data-testid="devreq-sort-hint" style={sortHintStyle(on)}>{hint}</span>
                                    </button>
                                  </th>
                                );
                              })}
                            </tr>
                          </thead>
                          <tbody>
                            {sortedItems.map(renderRow)}
                            {data && !error && items.length === 0 && (
                              <tr><td colSpan={headers.length} style={{ ...td, color: COLORS.textMuted, textAlign: 'center', padding: '24px' }}>{emptyText}</td></tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div style={{ padding: '10px 0', fontSize: '12px', color: COLORS.textSub }}>총 {total.toLocaleString()}건</div>
                    </section>
                  )}
                </>
              )}
            </div>
          </Page>
        </div>
        )}
        {detailOpen && (
          <>
            {/* 폭 조절 손잡이(넓은 화면 · 크게 보기 아닐 때) — marginRight:-6px = 상세 borderLeft 위에 겹쳐 레이아웃 폭을 먹지 않는다.
                zIndex 5 = 상세 내용 위 · 오버레이(99999)·창(Modal) 아래. */}
            {!isMobile && !expandedOn && (
              <div role="separator" aria-orientation="vertical" aria-label="상세 패널 너비 조절" data-testid="devreq-detail-resizer"
                tabIndex={0} aria-valuenow={detailShownW} aria-valuemin={DETAIL_W_MIN} aria-valuemax={detailWMaxFor(mainW)}
                title="드래그하여 너비 조절 · 더블클릭하면 기본 너비"
                onMouseDown={startDetailDrag} onDoubleClick={resetDetailW} onKeyDown={onDetailResizerKey}
                onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(100,116,139,.28)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent'; }}
                style={{ flex: '0 0 6px', width: '6px', marginRight: '-6px', position: 'relative', zIndex: 5, cursor: 'col-resize', background: 'transparent' }} />
            )}
            <DevRequestDetail
              item={detail.item}
              me={me}
              loading={detail.loading}
              error={detail.error}
              onClose={closeDetail}
              onEdit={(opts) => { if (detail.item) setForm({ mode: 'edit', item: detail.item, thumbs: opts?.thumbs || null }); }}
              onChanged={() => afterChange({ pinNav: true })}
              fullScreen={isMobile}
              width={isMobile || expandedOn ? undefined : detailShownW}
              nav={detailNav}
              expanded={expandedOn}
              onToggleExpand={isMobile ? undefined : toggleExpanded}
            />
          </>
        )}
      </main>
      {form && (
        <DevRequestForm
          key={form.mode === 'edit' ? `edit-${form.item.id}` : 'create'}
          mode={form.mode}
          item={form.mode === 'edit' ? form.item : null}
          me={me}
          round={form.mode === 'edit' ? roundById(form.item.round_id) : me?.open_round}
          departments={departments}
          detailThumbs={form.mode === 'edit' ? form.thumbs : null}
          onClose={() => setForm(null)}
          onSaved={onFormSaved}
        />
      )}
      {rankOpen && (
        <DevRequestRankPanel me={me} round={me?.open_round} onClose={() => setRankOpen(false)} onSaved={onRankSaved} />
      )}
    </AppShell>
  );
}
